// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditAvailabilityPopover {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 525px;
}
.EditAvailabilityPopover > .col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0;
}
.EditAvailabilityPopover > .col > .row {
  width: 100%;
  flex-wrap: nowrap;
  display: flex;
  justify-content: center;
}
.EditAvailabilityPopover > .col > .row:last-of-type {
  padding-bottom: 1rem;
}
.EditAvailabilityPopover > .col > .row {
  --bs-gutter-x: 1.2rem;
}
.EditAvailabilityPopover .FormField-Label {
  margin: 0 !important;
}
.EditAvailabilityPopover :not(.Select).btn {
  text-transform: uppercase;
  font-size: 0.9rem;
}
.EditAvailabilityPopover .Weekday-Button {
  position: relative;
  border: 1px solid var(--bs-primary);
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
}
.EditAvailabilityPopover .Weekday-Button .sv-warning {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  color: var(--bs-danger);
}
.EditAvailabilityPopover .Weekday-Button div:last-child {
  font-size: 1.25rem;
  line-height: 1rem;
}

.ConfirmationModal {
  --bs-modal-zindex: 1075;
}

.EditAvailabilityHeader {
  padding: 1rem 0;
}`, "",{"version":3,"sources":["webpack://./src/components/EditAvailabilityPopover/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;AACJ;AAAI;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AAEN;AADM;EACE,oBAAA;AAGR;AATI;EAQE,qBAAA;AAIN;AAAE;EACE,oBAAA;AAEJ;AACE;EACE,yBAAA;EACA,iBAAA;AACJ;AAEE;EACE,kBAAA;EACA,mCAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AAAJ;AAEI;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;AAAN;AAGI;EACE,kBAAA;EACA,iBAAA;AADN;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,eAAA;AAHF","sourcesContent":[".EditAvailabilityPopover {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 525px;\n\n  > .col {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    padding: 0;\n    > .row {\n      width: 100%;\n      flex-wrap: nowrap;\n      display: flex;\n      justify-content: center;\n      &:last-of-type {\n        padding-bottom: 1rem;\n      }\n      --bs-gutter-x: 1.2rem;\n    }\n  }\n\n  .FormField-Label {\n    margin: 0 !important;\n  }\n\n  :not(.Select).btn {\n    text-transform: uppercase;\n    font-size: 0.9rem;\n  }\n\n  .Weekday-Button {\n    position: relative;\n    border: 1px solid var(--bs-primary);\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    width: 100%;\n\n    .sv-warning {\n      position: absolute;\n      top: 0.25rem;\n      right: 0.25rem;\n      color: var(--bs-danger);\n    }\n\n    div:last-child {\n      font-size: 1.25rem;\n      line-height: 1rem;\n    }\n  }\n}\n\n.ConfirmationModal {\n  --bs-modal-zindex: 1075;\n}\n\n.EditAvailabilityHeader {\n  padding: 1rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
